import { useApi } from '../services';

export const useGetReportData = (idOperation) => useApi(
    `/v2/report/data/${idOperation}`,
    'GET',
    {},
    {}
);